import { makeStyles } from "@material-ui/core/styles";

const tabStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    paddingLeft: "5px",
    backgroundColor: "white !important",
  },
  tabBar: {
    boxShadow: "none !important",
    backgroundColor: "white !important",
    paddingLeft: "20px",
  },
  tabBox: {
    backgroundColor: "white !important",
    color: "black",
    borderBottom: "1px solid grey !important",
  },
  tabValue: {
    fontStyle: "normal",
    fontWeight: 550,
    fontSize: "19px",
    padding: "10px 30px",
    minWidth: "180px",
    textTransform: "none",
  },
  paddingAll: {
    padding: "0px 20px",
  },
}));

const topBarStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
    marginTop: "25px",
    marginLeft: "20px",
  },
  positionRelative: {
    position: "relative",
  },
  dFlex: {
    display: "flex",
    justifyContent: "flex-end",
  },
  dFlex1: {
    display: "flex",
    justifyContent: "flex-start",
  },
}));

const buttonStyles = makeStyles((theme) => ({
  button: {
    width: "180px !important",
    height: "40px !important",
    marginRight: "20px !important",
    background: `linear-gradient(135deg, #0A2540 0%, #143A5E 100%)`,
    fontStyle: "normal",
    marginLeft: "15px !important",
    fontWeight: 450,
    fontSize: "15px !important",
    [theme.breakpoints.down("md")]: {
      width: "120px",
      padding: "10px 10px",
      fontSize: "10px",
    },
  },
}));

const searchBarStyles = makeStyles((theme) => ({
  search: {
    borderRadius: "4px",
    paddingTop: "0px",
    position: "static",
    height: "36px",
    color: "black",
    border: "1px solid #CCCCCC",
    backgroundColor: "rgba(0, 0, 0, 0.02);",
    "&:hover": {
      backgroundColor: "rgba(0, 0, 0, 0.02)",
    },
    [theme.breakpoints.up("sm")]: {
      width: "auto",
    },
    [theme.breakpoints.up("md")]: {
      marginLeft: 0,
      width: "250px",
      height: "40px",
      color: "black",
      background: "rgba(0, 0, 0, 0.02);",
    },
  },
  searchIcon: {
    padding: theme.spacing(0, 2),
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    top: "0px",
    left: "0px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  colorBlack: {
    color: "black !important",
  },
  inputRoot: {
    color: "black",
  },
  inputInput: {
    padding: "8px 40px !important",
    color: "black !important",
    paddingLeft: `calc(1em + ${theme.spacing(4)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("md")]: {
      width: "20ch",
    },
    "&::placeholder": {
      textOverflow: "ellipsis !important",
      color: "#606060 !important",
      opacity: 1,
      fontSize: "14px",
    },
  },
}));

export { tabStyles, topBarStyles, buttonStyles, searchBarStyles };
